<div class="" id="app_top_node">
  <prf-pages></prf-pages>
  <prf-overlay-busy></prf-overlay-busy>
  <prf-side-modal *ngIf="isShowSideModal"></prf-side-modal>
  <prf-center-modal *ngIf="isShowCenterModal"></prf-center-modal>
  <prf-loader-react></prf-loader-react>
  <prf-snackbar-react></prf-snackbar-react>
  <prf-cookie-agreement-modal></prf-cookie-agreement-modal>
</div>
